import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

export default function CardHeader(props) {
  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      style={props.margin ? { marginTop: props.margin } : null}
    >
      <Typography variant="h6">{props.title}</Typography>
      {props.canEdit ? (
        <Button onClick={props.actionClick} color="primary" size="small">
          {props.actionText ? props.actionText : "MODIFICA"}
        </Button>
      ) : null}
    </Grid>
  );
}
